import { useEffect, useState } from 'react';
import { Layout, Menu, Row, Col, Form, Input, Button, Checkbox, Tag, Typography, Divider, Select, message } from 'antd';
import { CheckCircleTwoTone } from '@ant-design/icons';
import {cityListArr, cityListObj} from './districtList';
const axios = require('axios');

const { Title } = Typography;
const { Option, OptGroup } = Select;



const AirtableForm = ({ setisModalVisible, fetchAvalDetails, loadingModal, setCityModal }) => {

    const [loading, setLoading] = useState(false);
    const [city, setCity] = useState(null);
    const [email, setEmail] = useState(null);
    const [submit, setSubmit] = useState(false); 

    const airtableURL = `https://api.airtable.com/v0/appK2OtTAUAdItovV/Main?api_key=keyDK80FJl78M2lJg`

    const handleChange = (value) => {
        // console.log(`selected district ${value}`);
        setCity(value);
        setCityModal(value);

    }

 


    const onFinish = (values) => {
        // console.log('Success:', values);

        const dataObj = {
            "fields": {
                "Email": values.email,
                "City": values.city,
                "Mobile": values.mobile,
                "Pincode": values.pincode
            }
        };
        setEmail(values.email);
        setLoading(true);
        setSubmit(false);
        axios.post(airtableURL, dataObj)
            .then(function (response) {
                // console.log("result::", response);
                setLoading(false);
                setSubmit(true);
            })
            .catch(function (error) {
                console.log('form submission error-->', error);
                message.error('Error. Please try again!')
                setLoading(false);
            });

    };

    const onFinishFailed = (errorInfo) => {
        // console.log('Failed:', errorInfo);
    };
 

    return (

        <>
            <div className={'form-wrapper'}>
                <Form

                    name="notification-form"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    disabled={submit}
                >
                    {!submit && <>
                        <div className="mt-8">
                            <Form.Item
                                name="city"
                                rules={[{ required: true, message: 'Please select your City' }]}

                            >
                                <Select placeholder={'Select your City'} className={'vn-form-field'} size={'large'} onChange={handleChange} disabled={loading || submit} showSearch  >
                                    {cityListArr.map((item,index)=>{ 
                                        return <Option key={index} value={item}>{item}</Option>
                                    })} 
                                </Select>

                            </Form.Item>
                        </div>
                        {
                            city && <>
                                <Form.Item
                                    name="email"
                                    rules={[{ required: true, type: 'email', message: 'Please enter your Email' }]}
                                >
                                    <Input className={'vn-form-field'} size={'large'} placeholder={'Email'} disabled={loading || submit} />
                                </Form.Item>
                                <Form.Item
                                    name="pincode"  
                                >
                                    <Input className={'vn-form-field'} size={'large'} placeholder={'Pincode (Optional)'} disabled={loading || submit} />
                                </Form.Item>
                                <Form.Item
                                    name="mobile" 
                                >
                                    <Input className={'vn-form-field'} size={'large'} placeholder={'Mobile (Optional)'} disabled={loading || submit} />
                                </Form.Item>


                                <Form.Item>
                                    <Button size={'large'} className={'w-full cta-btn mt-4'} type="primary" htmlType="submit" loading={loading} disabled={submit}>
                                        GET NOTIFIED
      </Button>
                                </Form.Item>
                            </>}

                    </>}

                    {submit && <div className={'mt-10 flex items-center flex-col'}>
                        <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '46px' }} />
                        <Title style={{ marginBottom: '12px' }} className={'mt-4 mb-0 succes-msg text-center'} level={2}>Thank you!</Title>
                        <Title style={{ marginTop: '6px' }} className={'mb-2 mt-0 succes-msg text-center'} level={4}>{`You’ll shortly receive an email at ${email}. Make sure to check your spam folder in case you can’t find it. You’re now signed up for updates on the nearest vaccine in ${city}.`}</Title>
                    </div>}

                    {city && !submit && <>
                        <div className={'flex flex-col items-center'}>
                            <p>OR</p>
                            <Button size={'large'} className={'w-full modal-btn'} onClick={() => fetchAvalDetails(cityListObj[city])} loading={loadingModal} >
                                SHOW AVAILABILITY LIST
      </Button>
                        </div>

                    </>
                    }
                </Form>
            </div>
        </>
    )
}

export default AirtableForm